module.exports = __webpack_public_path__ + "fonts/rubik-bold-webfont.3cee18ca.3cee18ca.woff2";